import { gql, TypedDocumentNode } from '@apollo/client';
import { DefaultApiResponse, DefaultArg } from '@libs/graphql';
import {
  MarketplaceAdditionalArgs,
  MarketplaceAssetType,
} from './getPopularMarketplaceAssets';

type GetAllMarketplaceAssets = MarketplaceAssetType;
type GetAllMarketplaceAssetsResponse = {
  marketplaceAssets: DefaultApiResponse<GetAllMarketplaceAssets[]>;
};
type GetAllMarketplaceAssetsArgs = MarketplaceAdditionalArgs;
export const getAllMarketplaceAssetsQuery: TypedDocumentNode<
  GetAllMarketplaceAssetsResponse,
  DefaultArg & GetAllMarketplaceAssetsArgs
> = gql`
  query GetAllMarketplaceAssets(
    $record: MarketplaceAssetsListRecord!
    $changeRecord: AssetsRateChangeRecord!
    $rateRecord: AssetsRateChangeRecord!
  ) {
    marketplaceAssets: getAllMarketplaceAssets(record: $record) {
      code
      name
      iconUrl
      isFavorite
      rate(record: $rateRecord)
      change(record: $changeRecord)
      marketCap
    }
  }
`;
